import React from 'react';
import { Flex, theme as antdTheme, Tooltip } from 'antd';

import './IBStatistic.css';

export const statisticsStyles = {
  title: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '1.2em',
  },
  subTitle: {
    fontSize: '14px',
  },
  info: {
    color: '#1A4B8B',
    backgroundColor: '#DCE7F5',
  },
  ok: {
    color: '#0D9487',
    backgroundColor: '#D0EEF0',
  },
  warning: {
    color: '#C2400C',
    backgroundColor: '#FFECD5',
  },
  critical: {
    color: '#B91B1C',
    backgroundColor: '#FCE3E3',
  },
  neutral: {
    color: '#ffffff',
    backgroundColor: '#2C4A71',
  },
};

type Props = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  value: React.ReactNode | number;
  valuePrefix?: React.ReactNode;
  valueSuffix?: React.ReactNode;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
  valueSuffixStyle?: React.CSSProperties;
  precision?: number;
};

const IBStatistic = ({
  title,
  subTitle,
  value,
  valuePrefix,
  valueSuffix,
  icon,
  style,
  valueStyle,
  precision,
  valueSuffixStyle,
}: Props) => {
  const { useToken } = antdTheme;
  const { token } = useToken();

  const titleStyle = { ...statisticsStyles.title, fontSize: token.fontSizeLG };

  //return (
  //   <Card
  //     title={title}
  //     styles={{
  //       header: { ...style, textAlign: 'center' },
  //       body: {
  //         ...style,
  //         paddingTop: '0px',
  //         paddingBottom: '16px',
  //         paddingRight: '22px',
  //         paddingLeft: '22px',
  //       },
  //       root: style,
  //     }}
  //   >
  //     <Flex align="center" justify="space-between" styleName="content">
  //       {icon ? <div styleName="icon">{icon}</div> : null}
  //       <Flex vertical justify="center" align="center" styleName="text">
  //         {subTitle ? (
  //           <Tooltip title={subTitle}>
  //             <div styleName="subtitle" style={statisticsStyles.subTitle}>
  //               {subTitle}
  //             </div>
  //           </Tooltip>
  //         ) : null}
  //         <div styleName="value" style={valueStyle}>
  //           {valuePrefix}
  //           {typeof value === 'number'
  //             ? value.toFixed(precision !== null ? precision : 0)
  //             : value}
  //           <span style={valueSuffixStyle}>{valueSuffix}</span>
  //         </div>
  //       </Flex>
  //     </Flex>
  //   </Card>
  // );

  return (
    <div styleName="card" style={style}>
      <Flex align="center" justify="space-between" styleName="content">
        {icon ? <div styleName="icon">{icon}</div> : null}
        <Flex vertical justify="center" align="center" styleName="text">
          <Tooltip title={title}>
            <div styleName="title" style={titleStyle}>
              {title}
            </div>
          </Tooltip>
          {subTitle ? (
            <Tooltip title={subTitle}>
              <div styleName="subtitle" style={statisticsStyles.subTitle}>
                {subTitle}
              </div>
            </Tooltip>
          ) : null}
          <div styleName="value" style={valueStyle}>
            {valuePrefix}
            {typeof value === 'number'
              ? value.toFixed(precision !== null ? precision : 0)
              : value}
            <span style={valueSuffixStyle}>{valueSuffix}</span>
          </div>
        </Flex>
      </Flex>
    </div>
  );
};

export default IBStatistic;
